import {Pipe, PipeTransform} from '@angular/core';
import {MatchreportService} from '../modules/shared/service/matchreport.service';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'matchreportStructurePipe',
    standalone: true
})
export class MatchreportStructurePipe implements PipeTransform
{
  constructor(private matchreportService: MatchreportService,
              private translate: TranslateService)
  {
  }

  transform(value: string): string
  {
    if (value)
    {
      const matchReportItem = this.matchreportService.getMatchReportStructure(value, this.translate);
      if (matchReportItem)
      {
        let s = '';
        for (const block of matchReportItem.blocks)
        {
          if (s.length > 0)
            s += ' | ';
          if (block.code && block.countMatches)
            s += block.countMatches + 'x' + block.codeText;
          else s += block.codeText;
        }
        return s;
        /*<div *ngFor="let block of matchReportItem.blocks; let i = index">
    <span *ngIf="i > 0">&nbsp;|&nbsp;</span><span *ngIf="block.code && block.countMatches">{{block.countMatches}}x{{block.codeText}}</span><span *ngIf="!(block.code && block.countMatches)">{{block.codeText}}</span>
  </div>*/
      }
    }
    return '';
  }
}
